/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactMethodSelect/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EmailSelect from './EmailSelect/index'
import Info from './Info/index'
import PhoneSelect from './PhoneSelect/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ContactMethodSelect({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsRequestPayment/Content/ContactMethodSelect"
  
}) {
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="ContactMethodSelect.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ContactMethodSelect.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Send to"
 color={dtTysiainputlabelColorPrimaryBase}
 size="normal"
 weight="medium"
 whiteSpace="nowrap"
 overflowX="hidden"
 marginBottom={dtSpaceMs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft={2}
 color={dtColorsRed600}
/>
</div>
<div
  data-testid="ContactMethodSelect.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1HjgJP': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-2-Z1HjgJP': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<EmailSelect
  viewPath={`${viewPath}/EmailSelect`}
/>
<PhoneSelect
  viewPath={`${viewPath}/PhoneSelect`}
/>
</div>
<Info
  viewPath={`${viewPath}/Info`}
/>
</div>
{children}
</React.Fragment>)
}